import { useCallback, useContext } from 'react';
import { BookingConfigContext } from '../../context/bookingConfigContext/bookingConfigContext';
import { BookingStepsContextState } from '../../context/bookingContext/bookingContext.types';
import { BookingQuoteContext } from '../../context/quoteContext/quoteContext';
import { getLanguage } from '../../i18n';
import useApi from '../services/api.service';
import {
  BookingQuote,
  BookingQuoteEnum,
  BookingQuoteInsuranceDataEnum,
  BookingQuoteInsuranceEnum,
} from '../../components/BookingWidget/BookingQuoteManagment/bookingQuote.interface';
import parseDataToQuote from '../../components/BookingWidget/BookingQuoteManagment/bookingQuoteManagment.mapper';
import { BookingConfigEnum } from '../../components/BookingWidget/bookingSteps.interface';
import { SendQuoteHook } from '../interfaces/useSendQuoteEmail.interface';
import { getUrlPlatformAndCatalog } from './url.helper';
import { useSessionContext } from '../../context/sessionContext/sessionContext';

const useSendQuoteEmail = (): SendQuoteHook => {
  const { bookingQuoteResponse } = useContext(BookingQuoteContext);
  const { bookingConfigData } = useContext(BookingConfigContext);

  const { sessionParams } = useSessionContext();
  const API = useApi(bookingConfigData, sessionParams);

  const prepareUrl = useCallback((): string => {
    const { cm360Endpoint } = bookingConfigData[BookingConfigEnum.DataCenter];
    return `${cm360Endpoint}/ui-proxy/ws-partners/api/documents/${getUrlPlatformAndCatalog(
      bookingConfigData,
    )}/products?locale=${getLanguage()}`;
  }, [bookingConfigData]);
  const { decodedSessionToken } = useSessionContext();
  const preparePayload = useCallback(
    (
      email: string,
      bookingSteps: BookingStepsContextState,
      quoteId: string,
    ): BookingQuote =>
      parseDataToQuote(
        bookingSteps,
        bookingConfigData,
        {
          email,
          quoteId,
        },
        decodedSessionToken,
      ),
    [bookingConfigData, decodedSessionToken],
  );

  const sendQuote = useCallback(
    async (
      email: string,
      bookingSteps: BookingStepsContextState,
      quoteId: string,
    ) => {
      const { psClient } = bookingConfigData[BookingConfigEnum.Channel];
      const payload = preparePayload(email, bookingSteps, quoteId);

      // TODO remove when P&S fix send a quote
      delete payload[BookingQuoteEnum.Insurance][
        BookingQuoteInsuranceEnum.InsuranceData
      ][BookingQuoteInsuranceDataEnum.SalesChannel];

      const url = prepareUrl();
      return API.post(url, payload, {
        headers: {
          'Client-Id': psClient,
        },
      });
    },
    [API, bookingConfigData, preparePayload, prepareUrl],
  );

  return {
    sendQuote,
  };
};

export default useSendQuoteEmail;
